export enum RouterNames {
  LOGIN = 'login',
  DASHBOARD = 'dashboard',
  AUTH_ERROR = 'Authorisation error',
}
